export enum PossibleNowSource {
  PhotoRegistration = 'photoregister',
  QRCode = 'qrcode',
  Web = 'web',
}
